import type { ReactNode } from 'react';
import { cn } from '../utils/cn';

export type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';

const tones: Record<BadgeVariant, string> = {
  default: 'bg-[var(--color-bg-card-hover)] text-[var(--color-text-primary)]',
  success: 'bg-[var(--color-success-light)] text-[var(--color-success)]',
  warning: 'bg-[var(--color-warning-light)] text-[var(--color-warning)]',
  danger: 'bg-[var(--color-danger-light)] text-[var(--color-danger)]',
  info: 'bg-[var(--color-info-light)] text-[var(--color-info)]',
};

export function Badge({
  variant = 'default',
  className,
  children,
}: {
  variant?: BadgeVariant;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        tones[variant],
        className
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
